import { NextPage } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetServerSidePropsContext } from "next";
import StrategyFS7 from "components/pages/strategy/FS7";

interface Props {}

const StrategyFS7Page: NextPage<Props> = ({}) => {
  return <StrategyFS7 />;
};
export default StrategyFS7Page;

export async function getServerSideProps(context: GetServerSidePropsContext) {
  let locale = context.locale || context.defaultLocale || "ko";

  return {
    props: {
      ...(await serverSideTranslations(locale, ["strategy"])),
    },
  };
}
